import layout from '@/layout'

export default {
  path: '/marketing',
  component: layout,
  redirect: '/marketing/birthday',
  name: 'marketingBirthday',
  meta: {
    title: 'marketing',
    icon: 'el-icon-box'
  },
  children: [
    {
      path: '/marketing/birthday',
      name: 'marketingBirthday',
      component: () => import('@/views/birthday/index'),
      meta: {
        title: 'marketingBirthday',
        icon: 'el-icon-box'
      }
    }
  ]
}
